export default __webpack_public_path__ + "static/media/gallery159_3.2c80c4b6.png";